// Hooks
import { useScrollTopHook } from './hooks/scroll-top.hook';
// Types
import { ScrollTopComponentType } from './types/scroll-top.component.type';

const ScrollTopComponent = (props: ScrollTopComponentType): null => {
  useScrollTopHook(props);

  return null;
};

export { ScrollTopComponent };
